export const StorageKeys = {
  FORGOT_PASSWORD_PHONE: 'forgot-password.phone',
};
